"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
exports.light = {
    ad: pro_light_svg_icons_1.faAd,
    analytics: pro_light_svg_icons_1.faFileChartLine,
    appAdminsOnly: pro_light_svg_icons_1.faLockAlt,
    arrowDown: pro_light_svg_icons_1.faArrowUp,
    arrowLeft: pro_light_svg_icons_1.faArrowLeft,
    arrowRight: pro_light_svg_icons_1.faArrowRight,
    arrowUp: pro_light_svg_icons_1.faArrowDown,
    bracketsCurly: pro_light_svg_icons_1.faBracketsCurly,
    calendar: pro_light_svg_icons_1.faCalendar,
    chevronRight: pro_light_svg_icons_1.faChevronRight,
    clipboard: pro_light_svg_icons_1.faClipboard,
    clipboardSuccess: pro_light_svg_icons_1.faClipboardCheck,
    close: pro_light_svg_icons_1.faTimes,
    columns: pro_light_svg_icons_1.faColumns,
    contentFeed: pro_light_svg_icons_1.faRss,
    convert: pro_light_svg_icons_1.faWandMagic,
    deploy: pro_light_svg_icons_1.faCloudUploadAlt,
    desktop: pro_light_svg_icons_1.faDesktop,
    download: pro_light_svg_icons_1.faDownload,
    edit: pro_light_svg_icons_1.faPencilAlt,
    email: pro_light_svg_icons_1.faEnvelope,
    emailList: pro_light_svg_icons_1.faMailBulk,
    erase: pro_light_svg_icons_1.faEraser,
    exclamation: pro_light_svg_icons_1.faExclamationTriangle,
    externalLink: pro_light_svg_icons_1.faExternalLink,
    field: pro_light_svg_icons_1.faEdit,
    group: pro_light_svg_icons_1.faObjectGroup,
    happy: pro_light_svg_icons_1.faSmile,
    hide: pro_light_svg_icons_1.faEyeSlash,
    history: pro_light_svg_icons_1.faHistory,
    home: pro_light_svg_icons_1.faHome,
    hostedFile: pro_light_svg_icons_1.faFile,
    html: pro_light_svg_icons_1.faCode,
    info: pro_light_svg_icons_1.faInfoCircle,
    mappedContent: pro_light_svg_icons_1.faFileAlt,
    maximize: pro_light_svg_icons_1.faWindowMaximize,
    message: pro_light_svg_icons_1.faCommentAlt,
    minimize: pro_light_svg_icons_1.faWindowMinimize,
    notFound: pro_light_svg_icons_1.faCompassSlash,
    pause: pro_light_svg_icons_1.faPauseCircle,
    play: pro_light_svg_icons_1.faPlayCircle,
    plus: pro_light_svg_icons_1.faPlus,
    question: pro_light_svg_icons_1.faQuestion,
    reload: pro_light_svg_icons_1.faSync,
    repeater: pro_light_svg_icons_1.faLayerGroup,
    required: pro_light_svg_icons_1.faAsterisk,
    save: pro_light_svg_icons_1.faSave,
    search: pro_light_svg_icons_1.faSearch,
    searchClose: pro_light_svg_icons_1.faSearchMinus,
    show: pro_light_svg_icons_1.faEye,
    slot: pro_light_svg_icons_1.faCabinetFiling,
    social: pro_light_svg_icons_1.faShareAlt,
    spinner: pro_light_svg_icons_1.faSpinnerThird,
    square: pro_light_svg_icons_1.faSquare,
    success: pro_light_svg_icons_1.faCheck,
    template: pro_light_svg_icons_1.faFileCode,
    toggleOff: pro_light_svg_icons_1.faToggleOff,
    toggleOn: pro_light_svg_icons_1.faToggleOn,
    trash: pro_light_svg_icons_1.faTrash,
    unlock: pro_light_svg_icons_1.faUnlock,
    upload: pro_light_svg_icons_1.faUpload,
    user: pro_light_svg_icons_1.faUser,
    version: pro_light_svg_icons_1.faCodeBranch,
    workspace: pro_light_svg_icons_1.faBuilding,
    workspaceAdminsOnly: pro_light_svg_icons_1.faLock,
};
//# sourceMappingURL=light.js.map